<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('edit_file') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.px-6.pt-6.pb-10
      .mb-4
        .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('document_name') }}
        v-text-field.round-xl(:placeholder="$t('enter_item', { item: $t('document_name').toLowerCase() })" outlined dense height="48" hide-details="auto" v-model="name")
      .mb-4
        .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('notes') }} ({{ $t('optional') }})
        v-textarea.round-xl(:placeholder="$t('enter_description')" outlined hide-details height="88" v-model="notes")

    v-divider
    v-card-actions.py-3.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="save" color="primary" depressed :disabled="disabledButton" :loading="isLoading") {{ $t('save') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UploadAttachmentDialog',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    pid: {
      type: String,
      required: true,
    },
    file: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    name: '',
    notes: null,
    isLoading: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    disabledButton () {
      return this.name.trim().length === 0
    }
  },
  mounted () {
    this.name = this.file.name
    this.notes = this.file.notes
  },
  methods: {
    ...mapActions(['showMessage']),
    save () {
      this.isLoading = true
      let payload = { name: this.name }
      if (this.notes) { payload.notes =  this.notes }
      this.$axios.patch(`/clinics/${this.company.slug}/consultations/${this.pid}/attachments/${this.file.id}`, payload)
        .then(resp => {
          this.$emit('onUpdated', resp.data)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
